import ActionButton from 'components/ActionButton';
import SearchBar from 'components/Autosuggest/Autosuggest';
import React, { useEffect, useState } from 'react';
import { searchUserByName } from 'services/api/common';
import styles from './index.module.scss';
import qs from 'query-string';
import SubscriptionTypeDropdown from 'components/SubscriptionTypeDropdown';
import moment from 'moment';
import { DateRangePickerWrapper } from 'components/Date/DateRangePicker';

const Filter = props => {
  const [subscriptionId, setSubscriptionId] = useState<string>('');
  const [user, setUser] = useState<Record<string, any>>({});
  const [userId, setUserId] = useState<string>('');
  const [status, setStatus] = useState<string>('');
  const [doesNotHaveLocation, setDoesNotHaveLocation] = useState<boolean>(false);
  const [nextBoxSentAtStart, setNextBoxSentAtStart] = useState<string | null>(null);
  const [nextBoxSentAtEnd, setNextBoxSentAtEnd] = useState<string | null>(null);
  const [userEmail, setUserEmail] = useState<string>('');

  useEffect(() => {
    const {
      subscriptionId,
      userId,
      status,
      userEmail,
      doesNotHaveLocation,
      nextBoxSentAtStart,
      nextBoxSentAtEnd,
    } = qs.parse(props.location.search, { parseBooleans: true, parseNumbers: true });

    setSubscriptionId(subscriptionId?.toString() || '');
    setUserId(userId?.toString() || '');
    setStatus(status?.toString() || '');
    setDoesNotHaveLocation(!!doesNotHaveLocation);
    setNextBoxSentAtStart(nextBoxSentAtStart?.toString() || '');
    setNextBoxSentAtEnd(nextBoxSentAtEnd?.toString() || '');
    setUserEmail(userEmail?.toString() || '');
    // setStartDate(startDate?.toString() || null);
    // setEndDate(endDate?.toString() || null);
  }, []);


  const resetFilter = () => {
    setSubscriptionId('');
    setUser({});
    setUserId('');
    setStatus('');
    setDoesNotHaveLocation(false);
    setNextBoxSentAtStart(null);
    setNextBoxSentAtEnd(null);
    setUserEmail('');
    // setStartDate(null);
    // setEndDate(null);
    const filterData = {
      subscriptionId: '',
      userId: '',
      status: '',
      email: '',
      // startDate: '',
      // endDate: '',
    };
    props.onSubmit(filterData);
  };

  const handleSubmit = () => {
    let filterData: Record<string, any> = {
      subscriptionId,
      userId: user.id || userId,
      userEmail,
      status,
      nextBoxSentAtStart,
      nextBoxSentAtEnd,
    };
    if (doesNotHaveLocation) {
      filterData = {
        ...filterData,
        hasLocation: !doesNotHaveLocation,
      };
    }
    props.onSubmit(filterData);
  };

  const onDateSelectionChange = ({ startDate, endDate }: { startDate: Date; endDate: Date }) => {
    setNextBoxSentAtStart(moment(startDate).toISOString());
    setNextBoxSentAtEnd(moment(endDate).toISOString());
  };

  const handleUserSelect = (suggestion: Record<string,any>) => {
    const user: Record<string, any> = {};
    user.id = suggestion.objectId;
    user.name = suggestion.full_name;
    setUser(user);
    setUserId(user.id);
  };

  return (
    <form className={styles['filter-container']} onSubmit={handleSubmit}>
      <div className={styles['input-group']}>
        <div className={styles['label']}>Subscription Type</div>
        <SubscriptionTypeDropdown
          value={subscriptionId}
          onChange={setSubscriptionId}
        />
      </div>
      <div className={styles['autosuggest-group']}>
        <div className={styles['label']}>User</div>
        <div className={styles['autosuggest-input']}>
          <SearchBar
            isUser={true}
            value={user.name || ''}
            setValue={value => setUser({ ...user, name: value })}
            searchAPI={searchUserByName}
            searchAPIParamKey={'searchTerm'}
            onSuggestionClicked={handleUserSelect}
          />
        </div>
      </div>
      <div className={styles['input-group']}>
        <div className={styles['label']}>User ID</div>
        <input
          className={'form-control'}
          value={userId}
          onChange={e => setUserId(e.target.value)}
        />
      </div>
      <div className={styles['input-group']}>
        <div className={styles['label']}>User Email</div>
        <input
          className={'form-control'}
          value={userEmail}
          onChange={e => setUserEmail(e.target.value)}
        />
      </div>
      <div className={styles['input-group']}>
        <div className={styles['label']}>Next Box Sent At</div>
        <div className={styles['date-picker']}>
          <DateRangePickerWrapper
            startDate={nextBoxSentAtStart}
            endDate={nextBoxSentAtEnd}
            onDatesChange={onDateSelectionChange}
          />
        </div>
      </div>
      <div className={styles['input-group']}>
        <div className={styles['label']}>Status</div>
        <select value={status} onChange={e => setStatus(e.target.value)} className={'form-control'}>
          <option hidden={!!status} value={'default'}>Select a status</option>
          <option value={'active'}>ACTIVE</option>
          <option value={'canceled'}>CANCELED</option>
          <option value={'cancelled'}>CANCELLED</option>
          <option value={'hold'}>HOLD</option>
        </select>
      </div>
      <div className={styles['checkbox-group']}>
        <input
          type={'checkbox'}
          className={'form-control'}
          checked={doesNotHaveLocation}
          onChange={e => setDoesNotHaveLocation(e.target.checked)}
        />
        <div className={styles['checkbox-label']}>Does not have location</div>
      </div>
      {/* <div className={styles['input-group']}>
        <div className={styles['label']}>Start Date</div>
        <div className={styles['date-picker']}>
          <DatePicker
            className={'form-control'}
            selected={startDate ? moment(startDate).toDate() : null}
            onChange={(e: any) => setStartDate(formatDate(e, DATE_FORMATS.YYYY_MM_DD))}
          />
        </div>
      </div>
      <div className={styles['input-group']}>
        <div className={styles['label']}>End Date</div>
        <div className={styles['date-picker']}>
          <DatePicker
            className={'form-control'}
            selected={endDate ? moment(endDate).toDate() : null}
            onChange={(e: any) => setEndDate(formatDate(moment(e), DATE_FORMATS.YYYY_MM_DD))}
          />
        </div>
      </div> */}
      <div className={styles['buttons-container']}>
        <ActionButton
          text={'Reset'}
          active={true}
          isLoading={false}
          onClick={resetFilter}
        />
        <ActionButton
          text={'Submit'}
          active={true}
          isSubmit={true}
          isLoading={false}
          onClick={handleSubmit}
        />
      </div>
    </form>
  );
};

export default Filter;